import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_BESTUREN: {
        url: "settings/besturen",
        method: "get",
    },

    GET_FUNCTIES: {
        url: "settings/functies",
        method: "get",
    },

    GET_SETTINGS_DETAILS: {
        url: "settings/details",
        method: "get",
    },

    UPDATE_GROUP: {
        url: "group/update",
        method: "post",
    },

    UPDATE_SETTINGS: {
        url: "settings/update",
        method: "post",
    },

   DOWNLOAD_PROTOCOL: (id) => ({
    url: `protocol/${id}`,
    method: "get",
}),
};

export const useBesturen = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_BESTUREN);

export const useFuncties = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_FUNCTIES);

export const useSettingsDetails = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_SETTINGS_DETAILS);

export const useUpdateGroup = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_GROUP);

export const useUpdateSettings = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_SETTINGS);

export const useDownloadProtocol = (id) =>
    useApiFetcherSWR(id ? API_ENDPOINT.DOWNLOAD_PROTOCOL(id) : null);